import { render, staticRenderFns } from "./FormInputerShort.vue?vue&type=template&id=0720882c&scoped=true&"
import script from "./FormInputerShort.vue?vue&type=script&lang=js&"
export * from "./FormInputerShort.vue?vue&type=script&lang=js&"
import style0 from "./FormInputerShort.vue?vue&type=style&index=0&id=0720882c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720882c",
  null
  
)

export default component.exports